import {Injectable, Signal} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AppConfig} from '../../app.config';

@Injectable({
  providedIn: 'root'
})
export class HubOverviewService {
  constructor(private http: HttpClient, private api: AppConfig) {}

  getHubOverview(
    pageIndex: number | Signal<number> = 0,
    perPage: number | Signal<number> = 50,
    sort: string | Signal<string> = 'createdAt',
    direction: string | Signal<string> = 'desc',
    search: string | Signal<string> = '',
    hasEvent: string | Signal<string> = '',
    hasLearnPath: string | Signal<string> = '',
    tags: (number | string)[] | Signal<(number | string)[]> = [],
    parishOrganizations: (number | string)[] | Signal<(number | string)[]> = [],
    activities: (number | string)[] | Signal<(number | string)[]> = [],
  ): Observable<any> {
    const pageVal = typeof pageIndex === 'function' ? pageIndex() : pageIndex;
    const perPageVal = typeof perPage === 'function' ? perPage() : perPage;
    const sortVal = typeof sort === 'function' ? sort() : sort;
    const directionVal = typeof direction === 'function' ? direction() : direction;
    const searchVal = typeof search === 'function' ? search() : search;
    const hasEventVal = typeof hasEvent === 'function' ? hasEvent() : hasEvent;
    const hasLearnPathVal = typeof hasLearnPath === 'function' ? hasLearnPath() : hasLearnPath;
    const tagsVal = typeof tags === 'function' ? tags() : tags;
    const parishOrganizationsVal = typeof parishOrganizations === 'function' ? parishOrganizations() : parishOrganizations;
    const activitiesVal = typeof activities === 'function' ? activities() : activities;

    return this.http.get<any>(
      `${this.api.baseUrl}/frontUser/getHubUsers?page=${pageVal + 1}&perPage=${perPageVal}&sort=${sortVal
      }&direction=${sortDir(directionVal)}&search=${encodeURIComponent(searchVal || '')}&hasEvent=${hasEventVal
      }&hasLearnPath=${hasLearnPathVal}&tags=${tagsVal.join(',')}&parishOrganizations=${parishOrganizationsVal.join(',')}&activities=${activitiesVal.join(',')}`,
      this.api.jsonTokenHeaders
    );
  }

  exportUserXLSX(sort: string | Signal<string> = 'createdAt',
    direction: string | Signal<string> = 'desc',
    search: string | Signal<string> = '',
    hasEvent: string | Signal<string> = '',
    hasLearnPath: string | Signal<string> = '',
    tags: (number | string)[] | Signal<(number | string)[]> = [],
    parishOrganizations: (number | string)[] | Signal<(number | string)[]> = [],
    activities: (number | string)[] | Signal<(number | string)[]> = []
  ): Observable<Blob> {
    const sortVal = typeof sort === 'function' ? sort() : sort;
    const directionVal = typeof direction === 'function' ? direction() : direction;
    const searchVal = typeof search === 'function' ? search() : search;
    const hasEventVal = typeof hasEvent === 'function' ? hasEvent() : hasEvent;
    const hasLearnPathVal = typeof hasLearnPath === 'function' ? hasLearnPath() : hasLearnPath;
    const tagsVal = typeof tags === 'function' ? tags() : tags;
    const parishOrganizationsVal = typeof parishOrganizations === 'function' ? parishOrganizations() : parishOrganizations;
    const activitiesVal = typeof activities === 'function' ? activities() : activities;
    return this.http.get(
      `${this.api.baseUrl}/frontUser/downloadHubUsersXLSX?sort=${sortVal
      }&direction=${sortDir(directionVal)}&search=${encodeURIComponent(searchVal || '')}&hasEvent=${hasEventVal
      }&hasLearnPath=${hasLearnPathVal}&tags=${tagsVal.join(',')}&parishOrganizations=${parishOrganizationsVal.join(',')}&activities=${activitiesVal.join(',')}`,
      {...this.api.jsonTokenHeaders, responseType: 'blob'}
    );
  }
}

function sortDir(dir: string): string {
  return dir || 'desc';
}
